import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { toast } from "react-toastify";

import { BASE_URL } from "../constants";
import { logout } from "./authSlice";

const rawBaseQuery = fetchBaseQuery({ baseUrl: BASE_URL });

// The backend allows one active device per admin. Once this account logs in
// somewhere else, every request from this device comes back with
// SESSION_REPLACED; logging out here lets PrivateRoute send the user to
// /login. Other 401s (e.g. role checks) are left to the calling screen.
const baseQuery = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  if (
    result.error?.status === 401 &&
    result.error?.data?.code === "SESSION_REPLACED"
  ) {
    // Several requests usually fail at once; the id shows the toast once.
    toast.error(result.error.data.error, { toastId: "session-replaced" });
    api.dispatch(logout());
  }
  return result;
};

export const apiSlice = createApi({
  baseQuery,
  tagTypes: ["Product", "User", "Order"],
  // Always refetch when a screen mounts (or its query args change) so
  // navigating between pages shows fresh data instead of the cached copy.
  // The cached data is still shown instantly while the refetch runs
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({}),
});
